<template>
    <section class="mt-16">
      <v-row>
        <v-col cols="12" offset="0" md="10" offset-md="1">    
            <v-breadcrumbs
              large
              :items="crumbs"
              divider="/"
              class="pl-0"
            ></v-breadcrumbs>
      
            <h1 class="primary--text">
              <v-icon color="primary">mdi-shield-account</v-icon> <span>Articulado</span>
            </h1>
      
            <div class="mt-16">
              <v-progress-linear v-if="loading"
                indeterminate
                class="global-loader"
              ></v-progress-linear>
      
              <template v-if="loading">
                <v-row>
                  <v-col cols="12" md="6">
                    <v-skeleton-loader
                      type="text"
                    ></v-skeleton-loader>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-skeleton-loader
                      type="text"
                    ></v-skeleton-loader>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-skeleton-loader
                      type="text"
                    ></v-skeleton-loader>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-skeleton-loader
                      type="text"
                    ></v-skeleton-loader>
                  </v-col>
                </v-row>
                <v-row class="mt-6" align="center" justify="space-around">
                  <v-skeleton-loader
                      type="button"
                    ></v-skeleton-loader>
                </v-row>
              </template>
              <MQT v-else method="update" :mqt="mqt"></MQT>
            </div>
          </v-col>
        </v-row>
    </section>
  </template>
  <script>
  import MQT from '@/components/KPI/MQT.vue'
  import KPISAPI from "@/api/KPIS.js";
  
  export default {
    components: {
        MQT
    },
    data: () => ({
        mqt : {},
        loading:true
    }),
    mounted(){
  
      if(!this.$store.getters.hasPermission(["super", "mqt.update"])) {
        this.$router.push('/forbidden');
      }
  
      KPISAPI.find(this.$route.params.id).then(({data}) => { this.mqt = data; this.loading = false;});
    },
    methods:{
      
    },
    computed: {
      crumbs: function() {
        return [
          {
            text: 'Dashboard',
            disabled: false,
            to: '/admin',
            exact: true,
          },
          {
            text: 'Listagem de Articulado',
            disabled: false,
            to: '/kpi/list',
            exact: true,
          },
          {
            text: 'Articulado',
            disabled: true,
            to: window.location.href,
            exact: true,
          },
        ];
      }
    }
  };
  </script>
  